import { render } from "./AssessCategories.vue?vue&type=template&id=02880684&scoped=true"
import script from "./AssessCategories.vue?vue&type=script&lang=js"
export * from "./AssessCategories.vue?vue&type=script&lang=js"

import "./AssessCategories.vue?vue&type=style&index=0&id=02880684&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02880684"]])

export default __exports__